import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';
import Dropdown from '../../Dropdown';
import Filter from '../Filter';

// TODO: rename. this is a horrible name.
const DropdownSelectFilter = ({
  onChange,
  label,
  options,
  defaultOptionValue,
  selectedOptionValue,
  menuWidth,
  filterButtonMaxWidth,
  variant,
  filterSpacingClass,
  fontSize,
  widthInside,
  tooltipPrependText,
  bgClassName,
  textColorClassName,
  disabled,
  withClear,
  removeBorderColor,
}) => {
  const isEmpty = useCallback(
    (removeColor) => removeColor || defaultOptionValue === selectedOptionValue,
    [defaultOptionValue, selectedOptionValue],
  );

  const getLabel = useCallback(() => (
    isEmpty()
      ? label
      : options.filter((op) => op.value === selectedOptionValue)[0].label),
  [selectedOptionValue, isEmpty, options, label]);

  const handleClick = useCallback((value) => {
    onChange(value);
  }, [onChange]);

  const clearFilter = useCallback(() => {
    onChange(defaultOptionValue);
  }, [onChange, defaultOptionValue]);

  return (
    <Filter
      menuWidthClass={menuWidth}
      filterMaxWidthClass={filterButtonMaxWidth}
      label={getLabel()}
      isFilterEmpty={isEmpty(removeBorderColor)}
      variant={variant}
      handleClear={clearFilter}
      filterSpacingClass={filterSpacingClass}
      fontSize={fontSize}
      widthInside={widthInside}
      tooltipPrependText={tooltipPrependText}
      bgClassName={bgClassName}
      textColorClassName={textColorClassName}
      disabled={disabled}
      withClear={withClear}
    >
      {options
        .map((item) => (
          <Dropdown.Item key={item.value} label={item.label} value={item.value} variant="select">
            <div className="p-1 self-center justify-self-center">
              {item.value === selectedOptionValue && <FaCheck className="ml-1 h-3 mr-4 text-theme" />}
            </div>
            <button
              type="button"
              onClick={() => handleClick(item.value)}
              className="col-span-4 text-left p-1 focus:outline-none text-left"
            >
              {item.label}
            </button>
          </Dropdown.Item>
        ))}
    </Filter>
  );
};

DropdownSelectFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })).isRequired,
  defaultOptionValue: PropTypes.number,
  selectedOptionValue: PropTypes.number,
  menuWidth: PropTypes.string.isRequired,
  filterButtonMaxWidth: PropTypes.string,
  filterSpacingClass: PropTypes.string,
  variant: PropTypes.string,
  fontSize: PropTypes.string,
  widthInside: PropTypes.string,
  tooltipPrependText: PropTypes.string,
  bgClassName: PropTypes.string,
  textColorClassName: PropTypes.string,
  disabled: PropTypes.bool,
  withClear: PropTypes.bool,
  removeBorderColor: PropTypes.bool,
};

DropdownSelectFilter.defaultProps = {
  selectedOptionValue: null,
  defaultOptionValue: null,
  variant: 'standard',
  filterButtonMaxWidth: 'm-w-filter',
  filterSpacingClass: undefined,
  fontSize: undefined,
  widthInside: undefined,
  tooltipPrependText: undefined,
  bgClassName: undefined,
  textColorClassName: undefined,
  disabled: false,
  withClear: false,
  removeBorderColor: false,
};

export default memo(DropdownSelectFilter);
